module.exports = __webpack_public_path__ + "img/card_home3.6d6b3e51.svg";